export const FETCH_TRANSLATIONS = 'TRANSLATIONS/FETCH_TRANSLATIONS';
export const FETCH_TRANSLATIONS_SUCCESS = 'TRANSLATIONS/FETCH_TRANSLATIONS_SUCCESS';

export interface FetchTranslations {
  type: typeof FETCH_TRANSLATIONS;
}

export interface FetchTranslationsSuccess {
  type: typeof FETCH_TRANSLATIONS_SUCCESS;
  payload: any;
}

export type TranslationActionTypes = FetchTranslations | FetchTranslationsSuccess;
